/**
 * Google Analytics, only with the visitor's consent.
 *
 * GA sets cookies, which in the EU need consent before they are written. So the
 * tag is not in index.html: nothing from Google loads until the visitor accepts
 * in the cookie bar, and the choice is remembered in this browser.
 *
 * Page views on route changes are counted by GA4's enhanced measurement
 * (browser history events), so the router needs no hook.
 */
const GA_ID = 'G-J706VP9SXN';
const KEY = 'hba_analytics_consent';

export function getConsent() {
  try {
    return localStorage.getItem(KEY); // 'granted' | 'denied' | null
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // Private mode: the bar comes back next visit, which is fine.
  }
  if (value === 'granted') loadAnalytics();
}

let loaded = false;

export function loadAnalytics() {
  if (loaded || typeof document === 'undefined') return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { anonymize_ip: true });

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}
